export const text = {
  login: "Log in",
  welcome: "Welkom",
  welcomedescription: "Voer uw e-mailadres in om door te gaan",
  email: "Email",
  getotp: "Ontvang OTP",
  processing: "Verwerken ",
  Pleaseenteravalidemailaddress: "Voer een geldig e-mailadres in ",
  Enteryouremailaddress: "Vul uw e-mailadres in",
};
